import { v4 as uuidv4 } from 'uuid'
import JobTypes from '../helpers/JobTypesEnum'
import { STORAGE_PATH } from '../config'

const diaz = {
  id: uuidv4(),
  name: 'Diaz',
  path: '/laura-diaz',
  bios: [
    'DIAZ é um dos projetos de Laura Diaz, multiartista e videomaker que trabalha na área de produção cultural, audiovisual, música popular e eletrônica. Como voz à frente dos projetos Teto Preto e Carneosso, Laura já se apresentou em festivais ao redor do Brasil e do mundo, e é co-fundadora da Mamba Negra — festa fundamental da cena de música eletrônica do Brasil — e do selo MAMBA rec.',
    'DIAZ is one of the projects of Laura Diaz, multi-artist and videomaker who works in the ​​cultural, audiovisual, popular and electronic music areas. As a voice leading Teto Preto and Carneosso, she has performed at festivals around Brazil and the world, and is the co-founder of Mamba Negra—the critical electronic music party in Brazil—and MAMBA rec label.',
  ],
  jobs: [
    {
      id: uuidv4(),
      title: 'Passa a Lata de L*L*',
      type: JobTypes.AUDIO,
      path: '/passa-a-lata-de-ll',
      image: '/assets/diaz/passa-a-lata-de-lolo.png',
      imageHover: '/assets/diaz/passa-a-lata-de-lolo_hover.png',
      texts: [
        'Clorofórmio, éter e essência.',
        'Chloroform, ether and essence.',
      ],
      pages: [
        {
          id: uuidv4(),
          // link: 'Track',
          // title: 'Passa a Lata de L*L*',
          // title: 'Passa a Lata de L*L* (track version)',
          src: `${STORAGE_PATH}/DIAZ/DIAZ+-+Passa+a+Lata+de+Loló.wav`,
          path: '/track',
        },
        // {
        //   id: uuidv4(),
        //   link: 'Video',
        //   type: JobTypes.VIDEO,
        //   title: 'Passa a Lata de L*L* (video version)',
        //   src: '/assets/TODO/videos/genesys_background.mp4',
        //   path: '/video',
        //   sizes: [1920 , 1080],
        // },
      ],
    },
  ],
}

export default diaz
